<div class="modal-body">
  <div class="load" *ngIf="loading">
    <i class="fa fa-spin fa-circle-notch"></i> {{ 'order.loadingContext' | translate }}
  </div>
  <ul class="block" *ngIf="!loading">
    <li class="order new" (click)="validate('')">
      <i class="select-icon fa fa-fw fa-plus"></i>
      <div class="code h5">{{ 'order.newOrder' | translate }}</div>
    </li>
    <div class="divider text-center" [attr.data-content]="'modal.or' | translate"></div>
    <li class="order" *ngFor="let o of orders" (click)="validate(o.code)">
      <i class="select-icon fa fa-fw fa-angle-right"></i>
      <div class="code h5">{{ o.code }}</div>
      <span class="date">{{ 'order.dateLabel' | translate }} {{ o.date | stringToDate }}</span>
    </li>
  </ul>
</div>
<div class="modal-footer">
  <button class="btn float-left" type="button" (click)="cancel()">
    <i class="fa fa-times"></i>
    {{ 'modal.cancelButton' | translate }}
  </button>
</div>